<ng-container>
	<base-display [scaleType]="'loadinganimation'"></base-display>
</ng-container>